import { render } from "./index.vue?vue&type=template&id=f7f923d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f7f923d6&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/dariem.kz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__